import { Link } from "react-router";
import { LocationIcon, MessageIcon, PhoneIcon } from "../../assets/svg";

const FooterCol = ({ title, links }: { title: string; links: { label: string; to: string }[] }) => (
  <div className="flex flex-col gap-4">
    <p className="font-brand text-[10px] font-black tracking-[0.2em] uppercase text-lochinvar mb-2">{title}</p>
    {links.map((l) => (
      <Link key={l.label} to={l.to} className="font-body text-sm text-slate-300 hover:text-lochinvar transition-all duration-300">
        {l.label}
      </Link>
    ))}
  </div>
);

export const Footer = () => (
  <footer className="bg-primary-950 pt-20 pb-10 px-6 md:px-11 relative overflow-hidden">
    {/* Decorative background element */}
    <div className="absolute bottom-0 right-0 w-1/3 h-1/2 bg-lochinvar/5 blur-[120px] pointer-events-none" />

    <div className="max-w-[1440px] mx-auto relative z-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-16 pb-16 border-b border-white/10">
        <div className="flex flex-col gap-6">
          <Link to="/" className="font-display font-bold text-white text-xl md:text-2xl whitespace-nowrap tracking-tight hover:opacity-80 transition-opacity">
            BudgIT Academy
          </Link>
          <p className="font-body text-sm text-slate-400 leading-relaxed max-w-[240px]">
            Mobilizing citizens through data-driven advocacy and professional civic training.
          </p>
          <div className="flex gap-4 mt-2">
            {/* Social placeholders could go here if needed */}
          </div>
        </div>

        <FooterCol title="Academy" links={[
          { label: "Our Curriculum", to: "/courses" },
          { label: "Impact Reports", to: "/" },
          { label: "Civic Fellowship", to: "/" },
          { label: "Community", to: "/" },
        ]} />

        <FooterCol title="Corporate" links={[
          { label: "BudgIT Home", to: "https://budgit.org" },
          { label: "Tracka Portal", to: "https://tracka.ng" },
          { label: "Data Discovery", to: "/" },
          { label: "Privacy Policy", to: "/" },
          { label: "Accessibility", to: "/" },
        ]} />

        <div className="flex flex-col gap-6">
          <p className="font-brand text-[10px] font-black tracking-[0.2em] uppercase text-lochinvar mb-2">Hq Contact</p>
          <div className="flex flex-col gap-4">
            <p className="flex items-start gap-4 text-sm text-slate-300 font-body">
              <span className="mt-0.5 shrink-0 text-lochinvar"><LocationIcon /></span>
              55 Moleye Street, Alagomeji, Lagos, Nigeria.
            </p>
            <p className="flex items-center gap-4 text-sm text-slate-300 font-body">
              <span className="text-lochinvar"><PhoneIcon /></span>(+234) 908 333 1633
            </p>
            <p className="flex items-center gap-4 text-sm text-slate-300 font-body border-t border-white/5 pt-4 mt-2">
              <span className="text-lochinvar"><MessageIcon /></span>info@budgit.org
            </p>
          </div>
        </div>
      </div>

      <div className="pt-10 flex flex-col md:flex-row items-center justify-between gap-6">
        <p className="font-brand text-[10px] font-bold text-slate-500 uppercase tracking-widest leading-none">
          © {new Date().getFullYear()} BudgIT Foundation. All rights reserved.
        </p>
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-3 text-[10px] text-slate-500 font-brand font-bold uppercase tracking-widest">
          <Link to="/" className="hover:text-white transition-colors">Data Privacy</Link>
          <Link to="/" className="hover:text-white transition-colors">Terms of Engagement</Link>
          <Link to="/" className="hover:text-white transition-colors">Cookie Management</Link>
        </div>
      </div>
    </div>
  </footer>
);
